// extracted by mini-css-extract-plugin
module.exports = {"grid":"loader_grid__E1Ygl","title":"loader_title__o_gU5","sub_title":"loader_sub_title__ARB0y","search":"loader_search__Md01P","features":"loader_features__OJOen"};